import { render, staticRenderFns } from "./WfirmaUnsettledPayments.vue?vue&type=template&id=6513e21a&"
import script from "./WfirmaUnsettledPayments.vue?vue&type=script&lang=js&"
export * from "./WfirmaUnsettledPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports